/**
 * data-testid values shared by the components and the Playwright page object. Change them here
 * and in playwright/pages/VacationBidManager.ts together.
 */
export const VACATION_BID_TEST_ID = {
  // Import awards
  importAwardsTab: "import-awards-tab",
  importAwardsCsvButton: "import-awards-csv-button",
  importAwardsCsvInput: "import-awards-csv-input",
  importAwardsSummary: "import-awards-summary",
  importAwardsHeldNotice: "import-awards-held-notice",
  importAwardsProblems: "import-awards-problems",
  importAwardsApplyButton: "import-awards-apply-button",
  importAwardsResult: "import-awards-result",

  // List window
  packageList: "vacation-bid-package-list",
  refreshButton: "vacation-bid-refresh-button",
  createButton: "create-vacation-bid-package-button",
  editButton: "edit-vacation-bid-package-button",
  statusFilter: "vacation-bid-status-filter",

  // Editor shell
  detailsTab: "vacation-bid-details-tab",
  crewTab: "vacation-bid-crew-tab",
  slotsTab: "vacation-bid-slots-tab",
  bidsTab: "vacation-bid-bids-tab",
  manageTab: "vacation-bid-manage-tab",
  awardsTab: "vacation-bid-awards-tab",
  publishAwardsButton: "vacation-bid-publish-awards-button",
  saveButton: "vacation-bid-save-button",
  resetButton: "vacation-bid-reset-button",
  retryLoadButton: "vacation-bid-retry-load-button",

  // Details tab
  title: "vacation-bid-package-title",
  isDisabled: "vacation-bid-package-is-disabled",
  baseAirport: "vacation-bid-package-base-airport",
  bidWindowOpen: "vacation-bid-window-open",
  bidWindowClose: "vacation-bid-window-close",
  secondBidWindowOpen: "vacation-bid-second-window-open",
  secondBidWindowClose: "vacation-bid-second-window-close",
  maxAwardsFirstRound: "vacation-bid-max-awards-first-round",
  bidBlockStart: "vacation-bid-block-start",
  bidBlockEnd: "vacation-bid-block-end",

  // Crew tab
  crewGroupsSelect: "vacation-bid-crew-groups-select",
  rebuildCrewCheckbox: "vacation-bid-rebuild-crew-checkbox",
  refreshCrewButton: "vacation-bid-refresh-crew-button",
  crewGrid: "vacation-bid-crew-grid",
  crewStatusFilter: "vacation-bid-crew-status-filter",
  crewRow: "vacation-bid-crew-row",
  importCrewCsvButton: "vacation-bid-import-crew-csv-button",
  importCrewCsvInput: "vacation-bid-import-crew-csv-input",
  exportCrewCsvButton: "vacation-bid-export-crew-csv-button",
  buildCrewButton: "vacation-bid-build-crew-button",
  buildCrewDialog: "vacation-bid-build-crew-dialog",
  buildCrewConfirmButton: "vacation-bid-build-crew-confirm-button",
  buildCrewCancelButton: "vacation-bid-build-crew-cancel-button",
  removeCrewButton: "vacation-bid-remove-crew-button",
  removeCrewDialog: "vacation-bid-remove-crew-dialog",
  removeCrewConfirmButton: "vacation-bid-remove-crew-confirm-button",
  addCrewSelect: "vacation-bid-add-crew-select",
  addCrewButton: "vacation-bid-add-crew-button",
  entitlementChangeDialog: "vacation-bid-entitlement-change-dialog",
  entitlementApplyButton: "vacation-bid-entitlement-apply-button",
  entitlementDaysOnlyButton: "vacation-bid-entitlement-days-only-button",
  entitlementCancelButton: "vacation-bid-entitlement-cancel-button",

  // Slots tab
  slotsGrid: "vacation-bid-slots-grid",
  slotRow: "vacation-bid-slot-row",
  addSlotButton: "vacation-bid-add-slot-button",
  generateSlotsButton: "vacation-bid-generate-slots-button",
  importSlotsCsvButton: "vacation-bid-import-slots-csv-button",
  importSlotsCsvInput: "vacation-bid-import-slots-csv-input",
  exportSlotsCsvButton: "vacation-bid-export-slots-csv-button",
  saveSlotsButton: "vacation-bid-save-slots-button",
  discardSlotsButton: "vacation-bid-discard-slots-button",

  // View Bids tab
  refreshBidsButton: "vacation-bid-refresh-bids-button",
  viewBidsGrid: "vacation-bid-view-bids-grid",
  viewBidsRow: "vacation-bid-view-bids-row",
  rankedBidList: "vacation-bid-ranked-bid-list",
  rankedBidRow: "vacation-bid-ranked-bid-row",
  showAllBidsButton: "vacation-bid-show-all-bids-button",
  shortOnlyToggle: "vacation-bid-short-only-toggle",

  // Award Bids tab
  awardingSummary: "vacation-bid-awarding-summary",
  blockCapacityGrid: "vacation-bid-block-capacity-grid",
  blockCapacityChip: "vacation-bid-block-capacity-chip",
  showCurrentBidsToggle: "vacation-bid-show-current-bids-toggle",
  awardQueue: "vacation-bid-award-queue",
  awardQueueItem: "vacation-bid-award-queue-item",
  awardQueueSearch: "vacation-bid-award-queue-search",
  awardQueueDoneToggle: "vacation-bid-award-queue-done-toggle",
  awardQueueCounts: "vacation-bid-award-queue-counts",
  notSubmittedOnlyToggle: "vacation-bid-not-submitted-only-toggle",
  viewBidsSearch: "vacation-bid-view-bids-search",
  crewAwardPanel: "vacation-bid-crew-award-panel",
  awardButton: "vacation-bid-award-button",
  undoAwardButton: "vacation-bid-undo-award-button",
  makeShortButton: "vacation-bid-make-short-button",
  shortBlockChip: "vacation-bid-short-block-chip",
  awardWarning: "vacation-bid-award-warning",
  dismissWarningButton: "vacation-bid-dismiss-warning-button",
  awardQueueWarning: "vacation-bid-award-queue-warning",
  awardingRoundButton: "vacation-bid-awarding-round-button",
  viewBidsRoundButton: "vacation-bid-view-bids-round-button",
  crewLeftoverDays: "vacation-bid-crew-leftover-days",
  leftoverChoiceRow: "vacation-bid-leftover-choice-row",
  placeLeftoverButton: "vacation-bid-place-leftover-button",
  leftoverPlacementSelect: "vacation-bid-leftover-placement-select",
  skipCrewButton: "vacation-bid-skip-crew-button",
  completeCrewButton: "vacation-bid-complete-crew-button",
  reopenCrewButton: "vacation-bid-reopen-crew-button",
  awardingConfirmDialog: "vacation-bid-awarding-confirm-dialog",
  awardingConfirmButton: "vacation-bid-awarding-confirm-button",
  awardingCancelButton: "vacation-bid-awarding-cancel-button",

  // Manage Awards tab
  manageAwardsTab: "vacation-bid-manage-awards-tab",
  manageAwardsSummary: "vacation-bid-manage-awards-summary",
  changeWindowOpens: "vacation-bid-change-window-opens",
  changeWindowCloses: "vacation-bid-change-window-closes",
  changeWindowSlotsFrom: "vacation-bid-change-window-slots-from",
  changeWindowState: "vacation-bid-change-window-state",
  saveChangeWindowButton: "vacation-bid-save-change-window-button",
  deleteChangeWindowButton: "vacation-bid-delete-change-window-button",
  shareChangeWindowButton: "vacation-bid-share-change-window-button",
  closeChangeWindowButton: "vacation-bid-close-change-window-button",
  changeWindowSelect: "vacation-bid-change-window-select",
  changeRequestCard: "vacation-bid-change-request-card",
  changeRequestToggle: "vacation-bid-change-request-toggle",
  approveChangeRequestButton: "vacation-bid-approve-change-request-button",
  denyChangeRequestButton: "vacation-bid-deny-change-request-button",
  denyChangeRequestDialog: "vacation-bid-deny-change-request-dialog",
  denyChangeRequestReason: "vacation-bid-deny-change-request-reason",
  denyChangeRequestConfirmButton: "vacation-bid-deny-change-request-confirm-button",

  // NFA build
  buildNfasButton: "vacation-bid-build-nfas-button",
  nfaBuildResultsButton: "vacation-bid-nfa-build-results-button",
  nfaBuildDialog: "vacation-bid-nfa-build-dialog",
  nfaBuildProgress: "vacation-bid-nfa-build-progress",
  nfaBuildProblems: "vacation-bid-nfa-build-problems",
  nfaBuildRerunButton: "vacation-bid-nfa-build-rerun-button",
  nfaBuildStoppedAlert: "vacation-bid-nfa-build-stopped-alert",
  nfaBuildStalled: "vacation-bid-nfa-build-stalled",
  nfaBuildCloseButton: "vacation-bid-nfa-build-close-button",

  // CSV import dialog
  importCsvDialog: "vacation-bid-import-csv-dialog",
  importCsvIssues: "vacation-bid-import-csv-issues",
  importCsvConfirmButton: "vacation-bid-import-csv-confirm-button",
  importCsvCancelButton: "vacation-bid-import-csv-cancel-button",

  // Generate dialog
  generateDialog: "vacation-bid-generate-dialog",
  generateFirstSlotStart: "vacation-bid-slot-first-start",
  generateSlotLengthDays: "vacation-bid-slot-length-days",
  generateRepeatEveryDays: "vacation-bid-slot-repeat-every-days",
  generateDefaultCapacity: "vacation-bid-slot-default-capacity",
  generateBlackoutDates: "vacation-bid-slot-blackout-dates",
  generateWeeklyPreset: "vacation-bid-generate-weekly-preset",
  generateBackToBackPreset: "vacation-bid-generate-back-to-back-preset",
  generateConfirmButton: "vacation-bid-generate-slots-confirm-button",
  generateCancelButton: "vacation-bid-generate-slots-cancel-button",
} as const;
